import React, { useContext, useEffect, useState } from 'react'
import axios from 'axios'
import { get } from 'lodash'
import { BookInfo, MenuContext } from '../../contexts/menuContext'

const RelatedContent = () => {
  const [, , page] = useContext(BookInfo)
  const [, changeMenuStatus, , changeRightSidebar, userClosedMenu] = useContext(MenuContext)
  const [content, setContent] = useState(null)
  useEffect(() => {
    axios.get(`/bookreader/toolbox/related/${page}`).then((response) => {
      setContent(get(response, 'data.data.content.body'))
    })
  }, [page])
  return (
    <div className="footnotes-wrapper">
      <div className="footnotes-header">
        <div className="footnotes">
          <h2>Related Content</h2>
        </div>
        <div
          className="footnotes-close"
          onClick={() => {
            changeRightSidebar(false)
            changeMenuStatus(!userClosedMenu)
          }}
        ><svg xmlns="http://www.w3.org/2000/svg" id="Outlined" viewBox="0 0 32 32" fill="currentColor">
          <title/>
          <g id="Fill">
            <polygon points="28.71 4.71 27.29 3.29 16 14.59 4.71 3.29 3.29 4.71 14.59 16 3.29 27.29 4.71 28.71 16 17.41 27.29 28.71 28.71 27.29 17.41 16 28.71 4.71"/>
          </g>
        </svg>
        </div>

      </div>
      <div className="footnotes-wrapper-inner">
        <div className="related-content" dangerouslySetInnerHTML={{ __html: content }} />
      </div>
    </div>

  )
}

export default RelatedContent
